var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "breadcrumb" },
    [
      _c(
        "li",
        { staticClass: "breadcrumb-item" },
        [
          _c("router-link", { attrs: { to: "/Home/Index" } }, [
            _c("i", { staticClass: "fa fa-dashboard" }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.resource("Breadcrumb_Home")) +
                "\n        "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("id-dispenser", {
        attrs: { elements: _vm.breadcrumbs },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var idsPerElement = ref.idsPerElement
              return _vm._l(_vm.breadcrumbs, function(breadcrumb) {
                return _c("router-link", {
                  key: idsPerElement.get(breadcrumb),
                  attrs: { to: breadcrumb.to },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var href = ref.href
                          var route = ref.route
                          var navigate = ref.navigate
                          var isActive = ref.isActive
                          var isExactActive = ref.isExactActive
                          return [
                            _c(
                              "li",
                              {
                                staticClass: "breadcrumb-item",
                                class: { active: isExactActive }
                              },
                              [
                                !isExactActive
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: href },
                                        on: { click: navigate }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(breadcrumb.displayName) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  : [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(breadcrumb.displayName) +
                                          "\n                    "
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }